import { Instance, types } from 'mobx-state-tree';

export const FetchingState = types.model('FetchingState', {
  id: types.identifier,
  state: types.enumeration([
    'idle', // initial state, no data
    'pending', // fetching, no data
    'done', // fetched, data is ready
    'error' // fetched, error occurred
  ]),
  error: types.maybeNull(types.string),
  data: types.maybeNull(types.frozen<unknown>()),
})
  .actions(self => ({
    setDone(data: unknown) {
      self.state = 'done';
      self.data = data;
    },
    setError(error: string) {
      self.state = 'error';
      self.error = error;
    },
    setPending() {
      self.state = 'pending';
      self.error = null;
      self.data = null;
    },
    setIdle() {
      self.state = 'idle';
      self.error = null;
      self.data = null;
    }
  }))
  .views(self => ({
    get isDone() {
      return self.state === 'done' && self.data !== undefined;
    },
    get hasError() {
      return self.state === 'error';
    },
    get isPending() {
      return self.state === 'pending';
    },
    get isIdle() {
      return self.state === 'idle';
    }
  }));

export type IFetchingState = Instance<typeof FetchingState>;